import React from 'react'
import PropTypes from 'prop-types'
import ArchiveComponent from './ArchiveComponent'
import ReactGA from 'react-ga'
import { Button } from 'react-bootstrap'

import './archives.scss'
import LinkComponent from '../../../core/LinkComponent/LinkComponent'
import LoadingComponent from '../../../core/LoadingComponent/LoadingComponent'
import FieldGroupComponent from '../../../core/FieldGroupComponent/FieldGroupComponent'
import { SIGN_IN_PATH } from '../../../../constants/routes'

class ArchivesComponent extends React.Component {
    constructor(props) {
        super(props);

        this.showHideArchives = this.showHideArchives.bind(this);

        this.state = {
            showArchives: false,
        }
    }

    componentWillMount() {
        const { isLoading, getArchives } = this.props

        if (!isLoading) {
            getArchives();
        }
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Archives Page' });
        ReactGA.pageview(window.location.pathname);
    }

    showHideArchives = () => {
        const { getArchives, api } = this.props;
        this.setState({
            showArchives: !this.state.showArchives,
        });

        if (this.state.showArchives) {
            getArchives(api, 'latest');
        }
    }

    render() {
        const { title, content, archives, isLoading, api, onVersionSelect, user } = this.props

        if (isLoading) {
            return <LoadingComponent fullScreen />;
        }

        let versionList = Object.keys(archives).map((version) => {
            return archives[version].sdk.apiName
        }).reverse();

        let versionMapping = Object.keys(archives).map((version) => {
            return {
                version: version,
                versionName: archives[version].sdk.apiName,
                isSelected: archives[version].sdk.isSelected,
            };
        })

        return <div className="Archives-component">
            <h2>{title}</h2>
            <p className="content">{content} &nbsp;
                {user.uid && <span className="blue-text" onClick={() => this.showHideArchives()}>
                    <b>{this.state.showArchives ? 'Hide' : 'View'} Archives</b>
                </span>}
            </p>
            {!user.uid && <Button className="redirectToSignInButton">
                <LinkComponent className="redirectToSignIn" url={SIGN_IN_PATH} title="Log In To Download" />
            </Button>}
            {this.state.showArchives && user.uid && <FieldGroupComponent
                name="sdkVersion"
                type="select"
                label="SDK Version"
                formProps={{
                    id: 'sdkVersion',
                    options: versionList,
                    isLoading: isLoading,
                    api: api,
                    onVersionSelect: onVersionSelect,
                    versionMapping: versionMapping,
                }}
                className="version-select"
            />}
            {user.uid && Object.keys(archives).reverse().map((version, index) =>
                archives[version]['sdk']['isSelected'] && <ArchiveComponent
                    key={index}
                    version={version}
                    archive={archives[version]}
                />
            )}
        </div>
    }
}

ArchivesComponent.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    archives: PropTypes.object.isRequired,
    getArchives: PropTypes.func.isRequired,
    api: PropTypes.string.isRequired,
    onVersionSelect: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
}

export default ArchivesComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Archives/ArchivesComponent.js